// Common types shared between modal components to avoid circular dependencies

export enum AccountModalNames {
  SignUp = 'sign-up',
  SignUpCreator = 'sign-up-creator',
  SignUpFree = 'sign-up-free',
  SignUpAllPlans = 'sign-up-all-plans',
  Login = 'login',
  VerifyEmail = 'verify-email',
}

export enum ModalConversionPoints {
  AccountPage = 'account-page',
  AccountSidebar = 'account-sidebar',
  AccountDownloads = 'account-downloads',
  AudioAd = 'audio-ad',
  DownloadUpsell = 'download-upsell',
  DownloadUpsellBusiness = 'download-upsell-business',
  DownloadPremium = 'download-premium',
  DownloadSfx = 'download-sfx',
  DownloadLimit = 'download-limit',
  External = 'external',
  Header = 'header',
  PricingPage = 'pricing-page',
  SignUp = 'sign-up',
  HelpCenter = 'help-center',
  DownloadPremiumMg = 'download-premium-motion',
  ReturningUserLogin = 'returning-user-login',
  UpgradeModal = 'upgrade-modal',
  SwitchToYearlyModal = 'switch-to-yearly-modal',
  // AuthDialog contextual triggers — recorded in `conversion_source`
  // localStorage so the `purchase` event attributes which feature drove the
  // auth flow (vs the generic 'sign-up'). Used only by
  // useOpenAuthDialog; the legacy AccountModals path keeps its own points.
  AuthAddToBoard = 'auth-add-to-board',
  AuthPlaylistGenerator = 'auth-playlist-generator',
  AuthPartnerApplication = 'auth-partner-application',
  // DialogStage download journey (new-download-flow) entry points.
  DownloadFlowPremiumGate = 'download-flow-premium-gate',
  DownloadFlowSignUp = 'download-flow-sign-up',
  DownloadFlowFirstDownload = 'download-flow-first-download',
}

// Define a more specific type for modal props
export interface ModalProps {
  assetId?: number;
  tag?: string;
  // Common props passed to various modals
  welcomeMessageType?: string;

  // Add any other known props here

  // Allow for additional unknown props with a more specific type than 'any'
  [key: string]: unknown;
}

// Context interface shared by AccountModals
export interface AccountModalsContextType {
  currentModal: AccountModalNames | null;
  handleOpenChange: () => void;
  initialScreen?: string;
  modalProps?: ModalProps;
  setCurrentModal: (
    modal: AccountModalNames,
    screen?: string,
    props?: ModalProps
  ) => void;
}
